module.exports = __webpack_public_path__ + "static/media/roboto-light-webfont.35ab1505.ttf";